/**
 * KAKLET — startsidans fyra rutor. `.tiles` / `.tile` i prototypen.
 *
 * DET ÄR HELA NAVIGERINGEN. Båda startsidorna består av fyra kakel och
 * ingenting annat: Mitt jobb har Arbetsordrar / Tidrapport / Mil / Utlägg, och
 * Laget har Attestera / Laget idag / Inhyrda / Att fakturera. Kunden är en
 * arbetande chef med handskar på i ett trapphus — fyra stora ytor, inte en
 * meny.
 *
 * NOTISSIFFRAN (`.dot`) är ANTAL SAKER SOM VÄNTAR PÅ DIG, inte antal saker som
 * finns. "4" på Attestera är fyra veckor som väntar på din knapptryckning. Sätt
 * den aldrig till en total — då slutar den betyda något och blir ett tal ingen
 * tittar på.
 */

import type { ReactNode } from 'react';
import { Ikon } from './Ikon';
import type { Ikonnamn } from './Ikon';
import { useNavigering } from '../app/navigering';
import type { SkarmId } from '../app/skarmar';
import type { Sokvagsparametrar } from '../app/navigering';

export const Kakelrutnat = ({ children }: { readonly children: ReactNode }) => (
  <div className="tiles">{children}</div>
);

export interface Kakelprops {
  readonly ikon: Ikonnamn;
  readonly titel: ReactNode;
  /** Undertexten: "3 idag · 1 pågående". Kort, konkret, inget prat. */
  readonly text?: ReactNode;
  /** Antal saker som VÄNTAR PÅ DIG. Utelämnad eller 0 ritar ingen prick. */
  readonly notis?: number;
  /** Skärmen kaklet går till. Utelämna den och skicka `onClick` i stället. */
  readonly till?: SkarmId;
  readonly params?: Sokvagsparametrar;
  readonly onClick?: () => void;
}

export const Kakel = ({ ikon, titel, text, notis, till, params, onClick }: Kakelprops) => {
  const { ga } = useNavigering();
  const tryck =
    onClick ??
    (till === undefined
      ? undefined
      : () => {
          ga(till, params ?? {});
        });
  return (
    <button type="button" className="tile" onClick={tryck}>
      {notis !== undefined && notis > 0 && (
        <span className="dot">
          {notis}
          <span className="dold"> väntar på dig</span>
        </span>
      )}
      <span className="ti">
        <Ikon namn={ikon} storlek={26} tjocklek={1.7} />
      </span>
      <span className="tl">{titel}</span>
      {text !== undefined && <span className="tm">{text}</span>}
    </button>
  );
};
